var exports = {
  "D": "xcc377c0b--7ae5a0--title",
};

module.exports = exports;
